// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._30hxu{padding:.5rem .75rem;font-size:14px;font-weight:300;line-height:23px;font-family:var(--base-font);display:block;overflow:hidden;white-space:nowrap;-o-text-overflow:ellipsis;text-overflow:ellipsis}@media(max-width:767px){._30hxu{font-size:16px;line-height:26px;padding:1rem 1rem 0}}@media(max-width:767px){._30hxu:after{content:\"\";display:block;width:100%;height:1px;margin-top:1rem;background-color:#dcdddd}}._30hxu:not(._28DWB):not(._2vJ8k){cursor:pointer;color:#595757}._30hxu:hover:not(._28DWB):not(._2vJ8k){color:#0373f9;background-color:#e0eeff}._2vJ8k{color:#0373f9;font-weight:400}._28DWB{color:#dcdddd}._2dFbf{float:right;margin-left:.5rem}._2dFbf path[fill]{fill:#0373f9}.nnja1{margin-right:.5rem}.nnja1 path[fill]{fill:#595757}._30hxu:hover .nnja1 path[fill]{fill:#0373f9}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"dropdownItem": "_30hxu",
	"disabledDropdownItem": "_28DWB",
	"selectedDropdownItem": "_2vJ8k",
	"selectedCheckIcon": "_2dFbf",
	"icon": "nnja1"
};
module.exports = exports;
